import { QuestionMark } from '@mui/icons-material'
import { Box, Chip, SvgIconTypeMap, SxProps, Theme, Typography, useTheme } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { useState } from 'react'
import { Trans } from 'react-i18next'

export interface ChipSelectorProps {
  items: Record<string, string>
  icons?: (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string
  })[]
  selected: string | null
  onSelect: (item: string, idx?: number | undefined) => void
  onePerLine?: boolean
  more?: number
  sx?: SxProps<Theme>
}

export const ChipSelector = (props: ChipSelectorProps): JSX.Element => {

  const { items, icons, selected, onSelect, sx, onePerLine, more } = props
  const [all, setAll] = useState(more === undefined)
  const MORE_LIMIT = all || more === undefined ? 9999 : more
  const theme = useTheme()

  // TODO: DRY. (more) selector is in Schedule.tsx.

  return <Box sx={sx}>
    {Object.keys(items).map((item, idx) => {
      const Icon = icons ? (icons[idx] || QuestionMark) : QuestionMark

      return <Box key={idx} sx={{ display: idx >= MORE_LIMIT ? 'none' : (onePerLine ? 'block' : 'inline-block') }}>
        <Chip
          onClick={() => onSelect(item, idx)}
          data-cy={`list-item-${items[item]}`}
          aria-selected={selected === item}
          className={selected ? 'selected' : ''}
          label={items[item]}
          icon={<Icon style={{ fill: theme.palette.iconColor.main }}/>}
          sx={{
            backgroundColor: item === selected ? theme.palette.selectedChip.main : '',
            mr: 1,
            my: 0.4,
          }}
        />
      </Box>
    })}
    {!all && Object.keys(items).length > MORE_LIMIT && <Typography data-cy="box-More" sx={{ cursor: 'pointer', mt: 1 }} onClick={() => setAll(true)}><Trans>(more)</Trans></Typography>}
  </Box>
}
